import cn from 'classnames';
import { ProductDetailedType } from '@/types';
import { getBackendImage } from '@/utils/getBackendImage';
import { formatPrice } from '@/utils/formatPrice';
import { parseText } from '@/utils/parseText';
import styles from './ProductReduced.module.scss';

type ProductReducedProps = {
  className?: string;
  product: ProductDetailedType;
  onClick?: () => void;
};

export function ProductReduced({
  className,
  product,
  onClick,
}: ProductReducedProps) {
  const wrapperClassName = cn(
    styles.product,
    {
      [styles.clickable]: !!onClick,
    },
    className,
  );

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <img
        src={getBackendImage(product.pictures[0])}
        alt={parseText(product.name)}
        className={styles.productImage}
      />
      <div className={styles.info}>
        <div className={styles.description}>
          <div className={styles.name}>{parseText(product.name)}</div>
          <div className={styles.params}></div>
        </div>
        <div className={styles.price}>
          <div className={styles.priceNew}>{formatPrice(product.price)} ₽</div>
          {product.oldPrice && (
            <div className={styles.discount}>
              <span className={styles.priceOld}>
                {formatPrice(product.oldPrice)}{' '}
              </span>
              {!!product.discountPercent && product.discountPercent > 0 && (
                <span className={styles.percent}>
                  -{product.discountPercent}%
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
